export default __webpack_public_path__ + "static/media/Fidelidade.8255af66.svg";